import {Injectable} from '@angular/core';
import {User} from "../Interfaces/user.interface";

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {

  public setToken(key: string, value: string): void {
    this.deletetToken(key);
    localStorage.setItem(key, value);
  }

  public getToken(key: string): string | null {
    return localStorage.getItem(key);
  }

  public hasToken(key: string): boolean {
    return this.getToken(key) !== null
  }

  public getUser(): User {
    return JSON.parse(this.getToken('user')!)
  }

  public deletetToken(key: string) {
    localStorage.removeItem(key)
  }
}
